// Sur iOS, le répertoire de données de l'app vit sous
//   .../Containers/Data/Application/<UUID>/...
// L'<UUID> du container peut CHANGER (réinstall, migration iOS, restauration) alors
// que les fichiers restent au MÊME sous-chemin relatif. Un audioPath ABSOLU stocké
// avec l'ancien <UUID> devient alors « mort » (Filesystem.readFile → fichier
// introuvable → upload en « erreur »), même si le fichier est bel et bien présent
// dans le container courant. On le répare en réécrivant la portion container.
//
// Module PUR (zéro import Capacitor) → testable sans device.

const APP_CONTAINER_RE = /\/Application\/[^/]+\//;

/**
 * Réécrit un chemin audio absolu pour pointer le container COURANT.
 *
 * @param audioPath chemin stocké (ex. `file:///.../Application/OLD/tmp/Rec/x.m4a`)
 * @param currentContainerRoot racine du container courant SANS slash final
 *        (ex. `file:///.../Application/CUR`), typiquement dérivée de
 *        `Filesystem.getUri({ directory: Library })` en retirant `/Library`.
 * @returns le chemin réécrit, ou l'entrée inchangée si elle ne ressemble pas à un
 *          chemin de container (ex. déjà relatif, ou chemin storage Supabase).
 */
export function rewriteToCurrentContainer(audioPath: string, currentContainerRoot: string): string {
  const match = APP_CONTAINER_RE.exec(audioPath);
  if (!match || match.index === undefined) return audioPath;
  const rest = audioPath.slice(match.index + match[0].length); // ex. tmp/CapacitorAudioRecorder/x.m4a
  const root = currentContainerRoot.replace(/\/$/, "");
  return `${root}/${rest}`;
}

/**
 * Dérive la racine du container à partir de l'URI d'un de ses sous-répertoires connus.
 * Ex. `file:///.../Application/CUR/Library` (+ suffixe optionnel) → `file:///.../Application/CUR`.
 * Renvoie null si l'URI ne contient pas le segment attendu (on ne réécrit alors rien).
 */
export function containerRootFromDirUri(dirUri: string, knownSuffix: string): string | null {
  const idx = dirUri.indexOf(`/${knownSuffix}`);
  if (idx < 0) return null;
  return dirUri.slice(0, idx);
}
